import { DeleteSectionCommand } from '../UndoRedo/DeleteSectionCommand.ts';
import { UndoRedoManagerCommandVersion } from '../UndoRedo/UndoRedoManagerCommandVersion.ts';
import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../grid/reduxStore/Store.ts';
import { useSocketClient } from '../../../providers/SocketContext.tsx';
import { useCheckDocumentLockStatus } from 'components/editor/hooks/useCheckDocumentLockStatus';
import { selectSections } from '../grid/reduxStore/editorSlice.ts';
import { useCurrentUser } from '../../../providers/UserProvider.tsx';

export function useDeleteSectionHandler() {
  const dispatch = useAppDispatch();
  const { socketClient } = useSocketClient();
  const checkDocumentLockStatus = useCheckDocumentLockStatus();
  const { data } = useCurrentUser();
  const userId = data.id;
  const sections = useAppSelector(selectSections);

  return useCallback(
    async (sectionId: string): Promise<boolean> => {
      const sectionIndex = sections.findIndex((s) => s.id === sectionId);
      const section = sections[sectionIndex];

      if (!section) {
        console.warn('useDeleteSectionHandler: section not found');
        return false;
      }

      const afterSectionId = sectionIndex > 0 ? sections[sectionIndex - 1].id : null;

      const command = new DeleteSectionCommand(
        { dispatch, userId, socketClient, checkDocumentLockStatus },
        {
          sectionId,
          afterSectionId,
        }
      );

      const success = await command.execute();

      if (success) {
        const undoRedoManager = UndoRedoManagerCommandVersion.getUndoRedoManager();
        undoRedoManager.pushUndoRedoCommands(command);
      }

      return success;
    },
    [dispatch, socketClient, checkDocumentLockStatus, sections]
  );
}
